import React from 'react'
import {Problem} from 'data/types'
import moment from 'moment'
import {Row, Col} from './Display'
import _ from 'lodash'
import i18n from 'i18n-js'
import UserAvatar from './UserAvatar'
import CalandarOff from '../assets/calandar-off.svg'
import CalandarOn from '../assets/calandar-on.svg'
import services from 'services'
import getImageSrcFromBlob from 'utils/blob'

type ProblemItemProps = {
  problem: Problem
  select: () => void
  deselect: () => void
  isSelected: boolean
  isFirstItem?: boolean
  isSidePanelOpen: boolean
}

export default function ProblemItem(props: ProblemItemProps) {
  const classes = [
    `flex flex-row items-center border rounded ${
      props.isSidePanelOpen ? 'mx-10' : 'mx-64'
    } mt-4 pl-4 pt-4 pb-4 hover:shadow-lg transition cursor-pointer duration-300 `,
  ]
  const titleClass = `text-sm font-semibold ${props.isSelected ? 'text-white' : 'text-itx-greyscale-2'}`
  const dateClassMd = `text-xs font-semibold pt-px pl-1 ${props.isSelected ? 'text-white' : 'text-itx-greyscale-3'}`
  const descriptionClassMd = `text-xs font-medium flex w-10/12 ${props.isSelected ? 'text-white' : 'text-itx-greyscale-2'}`

  if (props.isSelected) {
    classes.push('text-itx-primary-base bg-itx-primary-4')
  } else {
    classes.push('border-b bg-white hover:bg-gray-100')
  }

  const HideDetailView = () => {
    props.deselect()
    services.router.push(`/projects/${props.problem.projectId}`)
  }

  return (
    <div
      onClick={() => {
        if (props.isSelected) {
          return HideDetailView()
        }
        props.select()
        services.router.push(`/projects/${props.problem.projectId}/problems/${props.problem.id}`)
      }}
      className={classes.join(' ')}
    >
      <Col className="self-start md:self-center ">
        <img
          className="border h-20 w-20 object-cover"
          src={getImageSrcFromBlob(props.problem.blob, {
            w: 100,
            h: 100,
          })}
          alt={props.problem.title}
        />
      </Col>
      <Col className="flex-1 ml-4 mr-2 justify-between">
        <Row className="items-start flex flex-row justify-between items-center">
          <span className={titleClass}>{_.truncate(props.problem.title, {length: 70})}</span>
          <Row className="flex items-center pr-1 w-32 justify-end">
            <UserAvatar user={props.problem.creator} size={7} />
          </Row>
        </Row>
        <Row className={descriptionClassMd}>
          {props.isSidePanelOpen ? _.truncate(props.problem.description, {length: 70}) : _.truncate(props.problem.description, {length: 200})}
        </Row>
        <Row className="items-center mt-4">
          <div className="flex text-xs font-semibold self-start px-3 py-1 rounded-full text-itx-warning-3 bg-itx-warning-8">
            {i18n.t('solutions.counting', {count: props.problem.solutionsCount})}
          </div>
          <Row className="items-center pl-2 pb-px">
            <img className="h-4 w-4 object-cover" src={props.isSelected ? CalandarOn : CalandarOff} alt={'Calandar'} />
            <span className={dateClassMd}>{moment(props.problem.createdAt).startOf('minutes').fromNow()}</span>
          </Row>
        </Row>
      </Col>
    </div>
  )
}
